module.exports = {
      id: "light-50(1s) index-usage",
      viewBox: "0 0 33 32",
      url: __webpack_public_path__ + "sprite-83ccd1.smartcharts.svg#light-50(1s) index-usage",
      toString: function () {
        return this.url;
      }
    }